import { analytics } from 'shared/library/analytics';
import { createContactAttemptTracker } from 'shared/library/contact-attempt';

// Session storage survives web login redirects without linking other browser tabs.
// Native uses the tracker's in-memory fallback for the current app session.
export const contactTracking = createContactAttemptTracker({
  storage: {
    getItem: (key) =>
      (typeof window !== 'undefined' ? window.sessionStorage?.getItem(key) : null) ?? null,
    setItem: (key, value) => {
      if (typeof window !== 'undefined') window.sessionStorage?.setItem(key, value);
    },
  },
  emit: (name, params) => analytics.event(name, params),
});
